var app = angular.module("leonardo");

var FolderSelectorDialog = function($scope, $q, $state, FolderService, FolderFileService, AuthDataService,
                                    NotificationService, AccountUserService, PermissionService, DynamicFormRestService,
                                    AttachmentService, $timeout, FilterService) {

  $scope.attachmentService = AttachmentService;
  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';
  $scope.mode_folder = $scope.ngDialogData.mode_folder;
  $scope.disable_folder = $scope.ngDialogData.disable_folder;
  $scope.only_dynamic = $scope.ngDialogData.only_dynamic;
  $scope.folder = $scope.ngDialogData.folder;
  $scope.allfolder = $scope.ngDialogData.allfolder;
  $scope.account = $scope.ngDialogData.account;
  $scope.folderSelected = null;
  $scope.fileSelected = null;
  $scope.folders = [];
  $scope.files = [];
  $scope.activefolder = false;
  $scope.client_instance = $scope.ngDialogData.client_instance || null;
  if(angular.isArray($scope.ngDialogData.excludeFolder)){
    $scope.excludeFolder = $scope.ngDialogData.excludeFolder;
  }
  else{
    $scope.excludeFolder = !isNull($scope.ngDialogData.excludeFolder) ? [$scope.ngDialogData.excludeFolder]: [];
  }
  $scope.rootFolderSelected = false;
  $scope.rootFolder = $scope.ngDialogData.rootFolder;
  $scope.rootDisabled = $scope.ngDialogData.rootDisabled ? $scope.ngDialogData.rootDisabled : false;
  $scope.hover = '';


  $scope.actions = [{id:'move', name: 'Move'}, {id:'copy', name:'Copy'}];

  $scope.action = $scope.ngDialogData.action ? $scope.ngDialogData.action : 'move';

  $scope.setHover = function(hover) {
    $scope.hover = hover;
  };

  $scope.refresh = function() {
    $scope.folderSelected = null;
    $scope.fileSelected = null;
    var defer = $q.defer();
    var filters = {disable_pagination: true, account: $scope.account};

    switch ($scope.mode) {
      case 'normal':
        filters['root_type_tree'] = 'library';
        break;
      case 'property':
        filters['root_type_tree'] = 'setup_property';
        break;
      case 'portfolio':
        filters['root_type_tree'] = 'setup_portfolio';
        break;
      case 'account':
        filters['root_type_tree'] = 'setup_account';
        break;
    }
    var promises = [];
    $scope.folders = [];
    $scope.files = [];
    var folder_ids = [];
    var defer_array = [];
    filters['move_summary'] = true;
    if ((!$scope.activefolder ? ($scope.allfolder && $scope.allfolder.length > 0) : $scope.folder && [$scope.folder].length > 0)) {
      delete(filters['root_type_tree']);
    }

    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      filters['sector'] = $scope.ngDialogData.sector;
    }
    if(filters['root_type_tree']){
      defer_array = $q.defer();
      promises.push(defer_array.promise);
      FolderService.getlist(filters, true).then(function(folders) {
        $scope.folders = $scope.folders.concat(folders);
        defer_array.resolve();
      }, function() {
        $scope.folders = [];
        defer_array.resolve();
      });
    }
    else{
      angular.forEach((!$scope.activefolder ? $scope.allfolder : ($scope.folder && [$scope.folder])), function(folder, key){
        filters['parent'] = folder.id;
        folder_ids.push(folder.id);
        defer_array[key] = $q.defer();
        promises.push(defer_array[key].promise);
        FolderService.getlist(filters, true).then(function(folders) {
          $scope.folders = $scope.folders.concat(folders);
          defer_array[key].resolve();
        }, function() {
          $scope.folders = [];
          defer_array[key].resolve();
        });
      });
    }
    if (($scope.mode_folder === 'files') && (!$scope.activefolder ? ($scope.allfolder && $scope.allfolder.length > 0) : [$scope.folder].length > 0)) {
      if ($scope.only_dynamic) {
        DynamicFormRestService.getlist({folder: folder_ids.join(','),disable_pagination: true, client_instance: $scope.client_instance}).then(function(response){
          $scope.files = response.results ? response.results : response;
        }, function () {
          $scope.files = [];
        })
      }
      else {
        FolderFileService.getlist({
          folder: folder_ids.join(','),
          disable_pagination: true
        }).then(function(response){
          $scope.files = response.results ? response.results : response;
        }, function () {
          $scope.files = [];
        });
      }
    }
    resolvePromises();
    function resolvePromises() {
      $q.all(promises).then(function () {
        var folders = $scope.folders;
        $scope.folders = [];
        angular.forEach(folders, function (folder) {
          if (!$scope.isExcludeFolder(folder) || $scope.only_dynamic) {
            $scope.folders.push(folder);
          }
        });
      });
    }
    return defer.promise;
  };

  $scope.isExcludeFolder = function (folder) {
    if ($scope.rootFolder && $scope.rootFolder.id == folder.id) {
      return true;
    }
    else if (_.contains($scope.excludeFolder, folder.id)) {
      return (!$scope.folder || $scope.folder.id != folder.id);
    }
  };

  $scope.isDynamicForm = function(file) {
    return !file.file && !file.document_file && !file.document_folder && !file.link;
  };

  $scope.canSelectFolder = function (folder) {
    var show = PermissionService.isOwner() ||
      (PermissionService.permissionAvailableAccount('permission_view_dynamic_forms') &&
        PermissionService.permissionAvailable('permission_add_dynamic_form') &&
        PermissionService.permissionAvailable('permission_edit_dynamic_form') &&
        PermissionService.permissionAvailable('permission_delete_dynamic_form'));
    if (folder) {
      if (folder.property) {
        let currentAccountProperties = FilterService.properties.filter(property => property.account == AccountUserService.currentAccountUser.account)
        angular.forEach(currentAccountProperties, function (property) {
          if (property.id == folder.property)
            show = true;
        });
      }
      if (folder.portfolio) {
        let currentAccountPortfolios = FilterService.portfolios.filter(portfolios => portfolios.account == AccountUserService.currentAccountUser.account )
        angular.forEach(currentAccountPortfolios, function (portfolio) {
          if (portfolio.id == folder.portfolio)
            show = true;
        });
      }
    }
    return show;
  };

  $scope.selectFolder = function(folder) {
    $scope.rootFolderSelected = false;
    $scope.folderSelected = folder;
  };

  $scope.selectFile = function(file) {
    $scope.fileSelected = file;
  };

  $scope.selectRootFolder = function() {
    $scope.folderSelected = $scope.rootFolder ? $scope.rootFolder : null;
    $scope.rootFolderSelected = true;
  };

  $scope.emptyFolderSelected = function() {
    return !$scope.rootFolderSelected && !$scope.folderSelected && !$scope.fileSelected;
  };

  $scope.getFolderClasses = function(folder) {
    var classes = [];
    if ($scope.rootFolderSelected || !$scope.folderSelected) return classes;
    if (folder.id == $scope.folderSelected.id) classes.push('active');
    return classes;
  };

  $scope.getFileClasses = function(file) {
    var classes = [];
    if (!$scope.fileSelected) return classes;
    if (file.id == $scope.fileSelected.id) classes.push('active');
    return classes;
  };

  $scope.getRootFolderClasses = function() {
    if ($scope.rootFolderSelected) return ['active'];
    return [];
  };

  $scope.goDown = function(folder) {
    $scope.resetRecords();
    $scope.activefolder = true;
    $scope.folder = folder;
    $scope.refresh();
  };

  $scope.goUp = function() {
    if (!$scope.folder.parent) {
      $scope.folder = null;
      $scope.activefolder = false;
      $scope.refresh();
    }
    else{
      FolderService.get($scope.folder.parent).then(function(folder) {
        if (!folder.root_account) {
          $scope.folder = folder;
        }
        else {
          $scope.folder = null;
        }
        if(!$scope.folder || $scope.allfolder && $scope.allfolder.some(arr => { return ($scope.folder.id === arr.id)})){
          $scope.activefolder = false;
        }
        $scope.refresh();
      });
    }
  };

  $scope.submit = function() {
    if ($scope.emptyFolderSelected()) return;
    if ($scope.folderSelected) {
      $scope.confirm({destiny:$scope.folderSelected, action:$scope.action, document_folder: $scope.fileSelected});
    }
    else if ($scope.fileSelected) {
      $scope.confirm({destiny:$scope.fileSelected, action:$scope.action, document_file: $scope.fileSelected});
    }
    $scope.confirm(null);
  };

  $timeout(function () {
    $scope.refresh();
  }, 0);

  $scope.resetRecords = function(){
    $scope.searchformValue = '';
  }
};

app.controller('FolderSelectorDialog', ['$scope', '$q', '$state', 'FolderService', 'FolderFileService', 'AuthDataService',
  'NotificationService', 'AccountUserService', 'PermissionService', 'DynamicFormRestService', 'AttachmentService', '$timeout', 'FilterService',
  FolderSelectorDialog]);
